import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState, useEffect } from "react";

import { EntmotivacionalUpdate } from "./EntmotivacionalUpdate";
import { EntmotivacionalDelete } from "./EntmotivacionalDelete";

export function EntmotivacionalEdit(props) {
  const entmotivacional = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = entmotivacional.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [entmotivResp, setEntmotivResp] = useState(
    entmotivacional.meta?.entmotivResp
  );
  const [entmotivFecha, setEntmotivFecha] = useState(
    entmotivacional.meta?.metaFecha
  );
  const [entmotivObs, setEntmotivObs] = useState(
    entmotivacional.meta?.entmotivObs
  );
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let entmotivacionalId = entmotivacional.id;

  const entmotivDate = new Date(entmotivacional.date);
  const diffDate = Math.abs(new Date() - entmotivDate) / 36e5;

  const submitEntmotivacional = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    try {
      await EntmotivacionalUpdate(
        entmotivResp,
        entmotivFecha,
        entmotivObs,
        tratamientoId,
        pacienteId,
        entmotivacionalId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/antecedentes/entrevista-motivacional/${entmotivacionalId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await EntmotivacionalDelete(entmotivacionalId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id="content">
        {entmotivacional.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id="formUpdatelement" onSubmit={submitEntmotivacional}>
            <fieldset id="disabledContainer">
              <div className="grid--2col">
                <div className="field">
                  <label htmlFor="entmotivResp">Responsable</label>
                  <div className="control">
                    <input
                      className="input"
                      id="entmotivResp"
                      required
                      type="text"
                      value={entmotivResp}
                      onChange={(e) => setEntmotivResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="entmotivFecha">Fecha entrevista</label>
                  <div className="control">
                    <input
                      className="input"
                      id="entmotivFecha"
                      required
                      type="date"
                      value={entmotivFecha}
                      onChange={(e) => setEntmotivFecha(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="field">
                <label htmlFor="entmotivObs">Observaciones</label>
                <div className="control">
                  <textarea
                    className="textarea"
                    name="entmotivObs"
                    id="entmotivObs"
                    value={entmotivObs}
                    onChange={(e) => setEntmotivObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id="actions">
          {(diffDate <= 72 || props.userRole.includes("administrador")) && (
            <button
              className="button is-link"
              id="saveButton"
              form="formUpdatelement"
              type="submit"
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : "Guardar"}
            </button>
          )}
          <Link
            className="button is-link is-light"
            to={`../${tratamientoId}/antecedentes/entrevista-motivacional/${entmotivacional.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes("administrador") && (
            <button
              className="button is-danger"
              id="deleteButton"
              onClick={deleteItem}
              disabled={isDeletingButton}
            >
              {isDeletingButton ? <div className="spinner"></div> : "Eliminar"}
            </button>
          )}
        </div>
      )}
    </>
  );
}
